import { CatalogItemCard } from "./components/catalog-item-card"
import { useState, useEffect, useRef } from "react"
import { apiFetchCatalog } from "../api/api"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { apiAddNewExercise } from "../api/api"
import { Alert } from "@aws-amplify/ui-react"
import { setCatalogItems } from "../store/catalogSlice"
import { useAuthenticator } from "@aws-amplify/ui-react"
import { addNew } from "../store/exercisesSlice"
import { Loader } from "@aws-amplify/ui-react"
import { useCallback } from "react"
import CatalogGroupMenu from "./components/catalog-group-menu"
const groups = {
    "chest": { "en": "chest", "ru": "грудь" },
    "back": { "en": "back", "ru": "спина" },
    "shoulders": { "en": "shoulders", "ru": "плечи" },
    "biceps": { "en": "biceps", "ru": "бицепс" },
    "triceps": { "en": "triceps", "ru": "трицепс" },
    "forearms": { "en": "forearms", "ru": "предплечье" },
    "quads": { "en": "quads", "ru": "квадрицепс" },
    "glutes": { "en": "glutes", "ru": "ягодицы" },
    "hamstrings": { "en": "hamstrings", "ru": "бедро" },
    "core": { "en": "core", "ru": "кор" },
    "calves": { "en": "calves", "ru": "икры" }
}

export const CatalogGroupPage = ({
    searchText,
    language }) => {

    const [isLoading, setIsLoading] = useState(false)
    let params = useParams()
    const { user } = useAuthenticator((context) => [context.user]);
    const [alert, setAlert] = useState(null)
    const maxOrder = useSelector((state) => state.exercises.maxOrder)


    const catalogItems = useSelector((state) => {
        //console.log('catalog items')
        //console.log(state.catalog.items)
        return (state.catalog.items?.[params.group]?.[language])
    })

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const hasFetched = useRef(false)
    const fetchItems = useCallback(async () => {
        setIsLoading(true)
        if (!hasFetched.current) {
            const response = await apiFetchCatalog(language, groups[params.group][language])
            dispatch(setCatalogItems({
                items: response?.data,
                group: params.group,
                language: language
            }
            ))
            hasFetched.current = true
        }
        setIsLoading(false)
    }, [language, dispatch, params.group])

    function capitalize(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    useEffect(() => {
        if (catalogItems) {
            //console.log('catalog cached')
        } else {
            //console.log('no catalog found, fetching from server')
            fetchItems()
        }
    }, [catalogItems, fetchItems])

    return (
        <div style={{ height: 'calc(100vh - 120px)', overflow: 'auto' }}>

            <CatalogGroupMenu
                currentGroup={params.group}
                onGroupChange={(newGroup) => {
                    hasFetched.current = false
                    navigate(`/catalog/${newGroup}`)
                }}
                language={language}
            >

            </CatalogGroupMenu>
            {
                isLoading &&
                <div className="d-flex align-items-center justify-content-center">
                    <Loader></Loader>
                    <span>Loading...</span>
                </div>
            }
            {!isLoading &&
                <div className="d-flex justify-content-center flex-wrap"
                >
                    {catalogItems?.items?.filter((value, index) => (
                        searchText ? (value.name.toLowerCase().includes(searchText.toLowerCase())) : true
                    )).map((value, index) =>
                        <div className="col-12 col-lg-6 p-1" key={index}>
                            <CatalogItemCard
                                item={value || []}
                                onAddExercise={async (day) => {
                                    const element = { ...value }
                                    element.id = crypto.randomUUID()
                                    element.deleted = false
                                    element.modified = Date.now()
                                    element.timestamp = Date.now()
                                    element.day = day
                                    element.user = user.userId
                                    element.group = capitalize(value.muscleGroup)
                                    element.favorite = false
                                    delete element.language
                                    delete element.muscleGroup

                                    if (maxOrder)
                                        element.order = maxOrder + 1
                                    dispatch(addNew(element))
                                    await apiAddNewExercise(user.userId, element)
                                    setAlert("Item has been created")
                                }}
                                key={index} />
                        </div>
                    )}
                </div>
            }
            {alert &&
                <Alert
                    className="alert"
                    variation="success"
                    isDismissible={true}
                    hasIcon={true}
                    onDismiss={() => {
                        setAlert(null)
                    }}
                    heading="Success"
                >
                    {alert}
                </Alert>
            }
        </div>
    )
}